import { useNuxtApp } from "#imports";
export const useBugsnagNotifyThrownException = (error, user) => {
  return useNuxtApp().$bugsnag.notify(error, ($event) => {
    $event.errors.forEach((e) => {
      e.errorClass = error.errorClass || error.name || error.constructor.name;
    });
    if (user) {
      $event.setUser(user);
    }
    if ("toObject" in error) {
      $event.addMetadata("errorContext", error.toObject());
    }
  });
};
